import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { parseError } from '@/utils/axios';

import { cnmcQueryKeys } from './query-keys';

export function deleteCNMC(id: string): Promise<undefined> {
  return mediaManagerClient.delete(`/api/v1/cnmcs/${id}`);
}

type MutationFn = typeof deleteCNMC;

type UseDeleteCNMCParams = {
  config?: MutationConfig<MutationFn>;
};

export function useDeleteCNMC({ config }: UseDeleteCNMCParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    onError(error) {
      const { status } = parseError(error);
      console.error(error);

      if (status === 404) {
        return addErrorNotification(t('El proceso no existe'));
      }
      addErrorNotification(t('No se ha eliminado'), t('Ha habido un problema en el proceso'));
    },
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: cnmcQueryKeys.all });
      addSuccessNotification(t('Se ha eliminado un proceso'), t('El proceso ha sido un éxito'));
    },
    ...config,
    mutationFn: deleteCNMC,
  });
}
